import getSubjectExtraInfo from '../utils/get-subject-extra-info';

export default function createSubjectMenuItem(subject) {
	let item = $('<div class="item selected">').attr('data-value', subject.id).data('item', subject);
	let header = $('<div class="ui small header">').appendTo(item);
	let content = $('<div class="content">').text(subject.fullName).appendTo(header);
	$('<div class="sub header">').text(getSubjectExtraInfo(subject)).appendTo(content);

	return item;
}